if (!customElements.get('libertas-section-carousel')) {
  class LibertasSectionCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.carouselReady === 'true') return;
      this.dataset.carouselReady = 'true';
      this.viewport = this.querySelector('[data-section-carousel-viewport]');
      this.controls = this.querySelector('[data-section-carousel-controls]');
      this.previousButton = this.querySelector('[data-section-carousel-previous]');
      this.nextButton = this.querySelector('[data-section-carousel-next]');
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.previousButton?.addEventListener('click', () => this.move(-1), { signal });
      this.nextButton?.addEventListener('click', () => this.move(1), { signal });
      this.viewport?.addEventListener('scroll', () => this.updateControls(), { passive: true, signal });
      this.viewport?.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }, { signal });

      if (this.viewport && 'ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.viewport);
      }

      window.requestAnimationFrame(() => this.updateControls());
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
    }

    move(direction) {
      const firstItem = this.viewport?.querySelector('[data-section-carousel-item]');
      if (!firstItem) return;
      const gap = Number.parseFloat(getComputedStyle(this.viewport).columnGap) || 0;
      this.viewport.scrollBy({
        left: direction * (firstItem.getBoundingClientRect().width + gap),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    updateControls() {
      if (!this.viewport || !this.controls) return;
      const maximumScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      const isScrollable = maximumScroll > 2;
      this.controls.hidden = !isScrollable;
      if (this.previousButton) this.previousButton.disabled = !isScrollable || this.viewport.scrollLeft <= 2;
      if (this.nextButton) this.nextButton.disabled = !isScrollable || this.viewport.scrollLeft >= maximumScroll - 2;
    }
  }

  customElements.define('libertas-section-carousel', LibertasSectionCarousel);
}
